export default __webpack_public_path__ + "static/media/cplacement.581c9f8e.svg";